//@flow
import { HiverAxios } from 'h-commons';
import {
    FETCH_TASKS_ASSIGNED_DONE,
    FETCH_TASKS_ASSIGNED_FAILED,
    FETCH_TASKS_ASSIGNED_INIT
} from './types';

export function getTasksAssigned(userIds: Array<string | number>, smid) {
    return (dispatch: Function) => {
        dispatch({
            type: FETCH_TASKS_ASSIGNED_INIT
        });
        HiverAxios({
            url: `/users/checkOpenMailsAndSource`,
            type: 'GET',
            params: { userid: userIds, smid: smid },
            callback: (response) => {
                dispatch({
                    type: FETCH_TASKS_ASSIGNED_DONE,
                    payload: response.data
                });
            },
            onfail: (err) => {
                console.error(err);                
                dispatch({
                    type: FETCH_TASKS_ASSIGNED_FAILED
                });
            }
        });
    }
}